// extracted by mini-css-extract-plugin
module.exports = {"container":"_277jYKJLjOe4FH5K3VmpHt","restaurantsList":"PK5PG1_AN48S7xpV7OSbL"};